import {Ref as PanelRef} from '../../state/views/panel/types';
import {getFullFlowConfig} from '../../util/sectionFlowConfig';
import type {PanelBankSectionConfig} from './types';

// Log the duration of the first expanded panelbank section if over this threshold (ms)
export const PANELBANK_LOADING_INTERESTING_THRESHOLD = 0;

export type PanelLoadingState = {
  stopTimerCallback?(
    name: string,
    data: Record<string, unknown> | undefined
  ): void;
};

export type TimerEntry = {
  id: string;
  duration: number;
};

// Only certain panels can be tracked, there have a wandb loader component
const TRACKED_PANELS = ['Bar Chart', 'Run History Line Plot', 'Scatter Plot'];

export function getPanelsToTrack(
  panelBankSectionConfig: PanelBankSectionConfig,
  panelRefs: PanelRef[],
  panelSearchResults: Map<PanelRef, boolean> | undefined
): TimerEntry[] {
  const flowConfig = getFullFlowConfig(
    panelBankSectionConfig.name,
    panelBankSectionConfig.flowConfig
  );
  const numFirstPagePanels = flowConfig.columnsPerPage * flowConfig.rowsPerPage;

  if (numFirstPagePanels === 0 || panelBankSectionConfig.panels.length === 0) {
    return [];
  }

  let firstPagePanelsCount: number = 0; // includes non-tracked panels
  const firstPagePanels: TimerEntry[] = [];
  for (let i = 0; i < panelBankSectionConfig.panels.length; i++) {
    if (firstPagePanelsCount === numFirstPagePanels) {
      break;
    }

    // User is searching, only track panels that are in the search results
    if (panelSearchResults && !panelSearchResults.get(panelRefs[i])) {
      continue;
    }

    firstPagePanelsCount++;

    // Only track panel types with tracked loading spinners
    const viewType = panelBankSectionConfig.panels[i].viewType;
    if (!TRACKED_PANELS.includes(viewType)) {
      continue;
    }

    firstPagePanels.push({
      id: panelRefs[i].id,
      duration: 0,
    });
  }

  return firstPagePanels;
}
